import { isValueStringType } from '../../utils/common'

import {
  DEEPGRAM_QUOTA_CLOSE_CODES,
  DEEPGRAM_QUOTA_REASON_PATTERN,
  DeepgramWebSocketError,
  WEBSOCKET_NORMAL_CLOSE_CODE,
  WebSocketReadyState,
} from './useDeepgramWebSocket.constants'

export function isWebSocketNormalCloseCode(code) {
  return code === WEBSOCKET_NORMAL_CLOSE_CODE
}

export function getDeepgramUrl(baseUrl, query) {
  if (!query) {
    return baseUrl
  }

  const search = new URLSearchParams(query).toString()

  if (!search) {
    return baseUrl
  }

  return `${baseUrl}?${search}`
}

export function isWebSocketReadyStateOpen(readyState) {
  return readyState === WebSocketReadyState.Open
}

export function isWebSocketReadyStateConnecting(readyState) {
  return readyState === WebSocketReadyState.Connecting
}

export function mapDeepgramCloseToError(code, reason) {
  if (DEEPGRAM_QUOTA_CLOSE_CODES.has(code)) {
    return DeepgramWebSocketError.QuotaError
  }

  if (isValueStringType(reason) && DEEPGRAM_QUOTA_REASON_PATTERN.test(reason)) {
    return DeepgramWebSocketError.QuotaError
  }

  return DeepgramWebSocketError.ServiceError
}
